import {
    autocompleteFieldConstructor,
    dropdownFieldConfigConstructor,
    numberFieldConstructor,
    rangeFieldConfigConstructor,
    switchFieldConstructor,
} from "scenes/cohort-filters/filter-configs/fieldContructors";
import { Category } from "scenes/cohort-filters/filter-configs/categories";
import { nestedFieldConstructor } from "scenes/cohort-filters/filter-configs/fieldContructors/nestedField";
import { geneValues, sampleLocations } from "scenes/patient/anamnesis/component/section/MutationModalForm";

const chipSampleLocations = sampleLocations.map((value) => ({
    value,
    label: `anamnesis.chip.source.${value}`,
}));

export const chipFields = {
    ...numberFieldConstructor({
        category: Category.CHIP,
        pathToValue: "anamnesis.chipMutationData.values_count",
        label: "anamnesis.chip.mutationCount",
    }),
    ...nestedFieldConstructor({
        category: Category.CHIP,
        label: "anamnesis.chip.mutationData",
        nestedPath: "anamnesis.chipMutationData.values",
        allowOrCondition: true,
        canExclude: true,
        additionalFieldProperties: {
            "anamnesis.chipMutationData.values.vaf": {
                operator: "eq",
            },
        },
        nestedConfigs: [
            switchFieldConstructor({
                nestedComponent: true,
                pathToValue: "$nestedHasChipMutation$anamnesis.hasChipMutation",
            }),
            dropdownFieldConfigConstructor({
                pathToValue: "anamnesis.chipMutationData.values.gene",
                label: "anamnesis.chip.table.gene",
                nestedComponent: true,
                dropdownValues: geneValues,
                fieldWidth: 150,
            }),
            numberFieldConstructor({
                pathToValue: "anamnesis.chipMutationData.values.exon",
                label: "Exon",
                nestedComponent: true,
                fieldWidth: 50,
                withComparisonOperators: false,
            }),
            autocompleteFieldConstructor({
                pathToValue: "anamnesis.chipMutationData.values.dna",
                label: "anamnesis.chip.table.dna",
                fieldWidth: 150,
                nestedComponent: true,
            }),
            autocompleteFieldConstructor({
                pathToValue: "anamnesis.chipMutationData.values.protein",
                label: "anamnesis.chip.table.protein",
                fieldWidth: 150,
                nestedComponent: true,
            }),
            numberFieldConstructor({
                pathToValue: "anamnesis.chipMutationData.values.vaf",
                label: "anamnesis.chip.table.vaf",
                fieldWidth: 80,
                nestedComponent: true,
            }),
            dropdownFieldConfigConstructor({
                pathToValue: "anamnesis.chipMutationData.values.source",
                nestedComponent: true,
                dropdownValues: chipSampleLocations,
                label: "Source",
                fieldWidth: 180,
            }),
            rangeFieldConfigConstructor({
                nestedComponent: true,
                pathToValue: "anamnesis.chipMutationData.values.date",
                label: "Date",
                fieldWidth: 100,
            }),
        ],
    }),
};
